const XL_BOTTOM = 1200;
const DESKTOP_TOP = 1199;
const DESKTOP_BOTTOM = 960;
const TABLET_TOP = 959;
const TABLET_BOTTOM = 640;
const MOBILE_TOP = 639;
const MOBILE_BOTTOM = 320;

export {
    XL_BOTTOM,
    DESKTOP_TOP,
    DESKTOP_BOTTOM,
    TABLET_TOP,
    TABLET_BOTTOM,
    MOBILE_TOP,
    MOBILE_BOTTOM,
};
